import {InstantOfferSellerEntity} from './InstantOfferSellerEntity.js'

export class SellerEntitiesFactory {
  /**
   * @method
   * @returns {InstantOfferSellerEntity} instantOfferSellerEntity
   */
  static instantOfferSellerEntity = ({
    appraisal,
    contactDetails,
    instantOfferId,
    photoUrl,
    postalCode,
    title,
    vehicle,
    vehicleData
  }) =>
    new InstantOfferSellerEntity({
      appraisal,
      contactDetails,
      instantOfferId,
      photoUrl: photoUrl || '',
      postalCode,
      title,
      vehicle,
      vehicleData
    })
}
